/**
 * @Author: Nenad Brcic
 * @Date: 26.05.16
 * @Email: neno@neno.ch
 */

import React, { Component, PropTypes } from 'react';
import {hashHistory} from 'react-router';
import RouteTransition from '../RouteTransition';

import SearchForm from './SearchForm';
import AdvancedSearchForm from './AdvancedSearchForm'
import Branding from '../Branding';
import Navigation from './Navigation';
import ToggleNav from '../shared/ToggleNav';
import SwitchLanguage from './SwitchLanguage';
import ContentTemplate from '../ContentTemplate';
import BackLink from '../shared/BackLink';
import Information from './Information';

import localize from '../../localize';
import settings from '../../../config/settings';
import { isMobile } from '../../common';
import {
    setLanguage,
    getCurrentLanguage,
    setSimpleSearch,
    setAdvancedSearch,
    isNavigationActive,
    activateNavigation,
    deActivateNavigation,
    toggleIsNavigationActive,
} from '../../localData';

import {
    redirectIfVisitExpired,
} from '../../expiration';

class Main extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAdvancedSearch: false,
            isNavigationActive: false,
        };
    }

    componentWillMount() {
        redirectIfVisitExpired();
        this.advancedSearchFields = [
            'searchTitle',
            'searchYearFrom',
            'searchYearTo',
            'searchPerson',
            'searchMaterial',
            'searchInventoryNr'
        ];
        this.isAnimatingNavigation = false;
    }

    componentDidMount() {
        if (this.isRoot()) {
            const self = this;
            setTimeout(function () {
                self.showNavigation();
            }, 2000);
        }
    }

    componentWillReceiveProps() {
        redirectIfVisitExpired();
    }

    isRoot = () => {
        const hashParts = window.location.hash.split('/');
        return (
            hashParts.length < 3 ||
            (hashParts.length === 3 && hashParts[2].startsWith('?'))
        );
    };

    // animateNavigationOnRoot = () => {
    //     const self = this;
    //     this.isAnimatingNavigation = true;
    //     this.toggleNavigationEvent = new CustomEvent('toggle-navigation');
    //
    //     if (this.isRoot()) {
    //         window.setTimeout(function () {
    //             self.toggleNavigation();
    //             self.isAnimatingNavigation = false;
    //         }, 2000);
    //     }
    // };

    handleSimpleSearch = (q) => {
        setSimpleSearch(q);
        this.showSearchResults();
        this.hideNavigationOnMobile();
        // this.removeSplash();
    };

    handleAdvancedSearch = (searchObj) => {
        setAdvancedSearch(searchObj);
        this.hideNavigationOnMobile();
        this.showSearchResults();
        // this.removeSplash();
    };

    toggleAdvancedSearch = () => {
        this.setState({ isAdvancedSearch: !this.state.isAdvancedSearch });
    };

    hideNavigationOnMobile = () => {
        if( isMobile() ) {
            deActivateNavigation();
            this.updateView();
        }
    };

    showNavigation = () => {
        activateNavigation();
        this.updateView();
    };

    toggleNavigation = () => {
        toggleIsNavigationActive();
        this.setState({ isNavigationActive: !this.state.isNavigationActive });
    };

    // This is needed because otherwise
    // the component will not update
    updateView = () => {
        this.props.relay.setVariables({
            lastUpdate: Date.now().toString()
        });
    };

    removeSplash = () => {
        // deActivateSplashScreen();
    };

    showSearchResults = () => {
        hashHistory.push(`/${getCurrentLanguage()}/search`);
    };

    handleNavChange = () => {
        this.hideNavigationOnMobile();
        const detailHeader = document.querySelector('#detailHeader');
        if (detailHeader) {
            detailHeader.scrollIntoView();
        }
    };

    l = (key) => {
        const lang = getCurrentLanguage();
        const str = `${lang}.components.Navigation.${key}`;
        return localize(str);
    };

    switchLanguage = (lang) => {
        const oldLang = getCurrentLanguage();

        if(lang !== oldLang) {
            setLanguage(lang);
            const path = this.props.location.pathname;
            let redirect;
            if (path.indexOf(`/${oldLang}/`) > -1) {
                redirect = path.replace(`/${oldLang}/`, `/${lang}/`);
            } else {
                redirect = `/${lang}${path}`;
            }
            hashHistory.push(redirect);
        }
    };

    getNavItems = () => {
        const self = this;
        let navItems = [];
        if(!!settings.navigation && settings.navigation.length) {
            navItems = settings.navigation.map(function (item) {
                return { name: self.l(item.name), icon: item.icon, url: item.url };
            });
        }
        return navItems;
    };

    showBackLink = () => {
        const url = this.props.location.pathname;
        return url.indexOf(settings.routesWithVisibleBackLink) > -1;
    };

    animateContent = () => {
        // let showAnimation = true;
        // const url = this.props.location.pathname;
        // const notAnimatedRoutes = [
        //     '/object/',
        //     '/person/',
        // ];
        // for(let i = 0; i < notAnimatedRoutes.length; i++) {
        //     if (url.indexOf(notAnimatedRoutes[i]) > -1) {
        //         showAnimation = false;
        //     }
        // }
        // return showAnimation;
        return false; // Temporally disabling animation - does not work on their Vitra's devices
    };

    render() {
        let containerClass = ` ${ isNavigationActive() ? 'show' : 'hide' }-navigation`;
        if (this.isRoot()) {
            containerClass += ' show-splash-screen';
        }
        const isAdvancedSearch = this.state.isAdvancedSearch;

        return (
            <ContentTemplate>
                <div styleName="page-container" className={containerClass}>

                    <div styleName="page-canvas">
                        <div id="navigation" className="navigation2" styleName="navigation">
                            <div styleName="navigation-inner">
                                <Branding
                                    toggleNavigation={this.toggleNavigation}
                                    isNavigationActive={isNavigationActive()}
                                    isRoot={this.isRoot()}
                                />
                                <SearchForm
                                    handleSearch={this.handleSimpleSearch}
                                    placeholderText={ this.l('search.searchQuery') }
                                    doReset={ isAdvancedSearch }
                                />
                                <Navigation
                                    links={ this.getNavItems() }
                                    handleClick={ this.handleNavChange }
                                />
                                {
                                    !!settings.search.fields.advanced &&
                                    <AdvancedSearchForm
                                        handleSearch={this.handleAdvancedSearch}
                                        searchFields={this.advancedSearchFields}
                                        lang={getCurrentLanguage()}
                                        isAdvancedSearch={ isAdvancedSearch }
                                        toggleAdvancedSearch={this.toggleAdvancedSearch}
                                        doReset={ !isAdvancedSearch }
                                    />
                                }
                                <Information store={this.props.store} lang={getCurrentLanguage()} />
                                <SwitchLanguage
                                    currentLang={getCurrentLanguage()}
                                    languages={settings.languages.sort()}
                                    handleChange={this.switchLanguage}
                                />
                            </div>
                        </div>
                        <main id="main" styleName="main">
                            {
                                !this.isRoot() &&
                                <div>
                                    { this.showBackLink() ? (
                                        <BackLink />
                                    ) : null }
                                    <ToggleNav
                                        toggleNavigation={this.toggleNavigation}
                                        isNavigationActive={isNavigationActive()}
                                    />
                                </div>
                            }
                            <div styleName="content">
                                {
                                    this.animateContent() ? (
                                        <RouteTransition pathname={ this.props.location.pathname }>
                                            { this.props.children }
                                        </RouteTransition>
                                    ) : (
                                        this.props.children
                                    )
                                }
                            </div>
                        </main>
                    </div>
                </div>
            </ContentTemplate>
        )
    }
}

export default Main;


// WEBPACK FOOTER //
// ./app/components/Main/Main.jsx